<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>
<br />

<div class="container">
    <div class="row">
        <div class="col-12">
            <h1 class="mb-2">{{ subscriptionKey ? 'Edit' : 'Create' }} {{ subscription?.paymentMechanismName || 'Manual' }} Subscription</h1>
            <p class="text-muted mb-4" *ngIf="!subscriptionKey || subscription?.type === SubscriptionType.MANUAL">
                Manual subscriptions are for tracking external agreements. They do not generate invoices or require real clients/parkings in the system.
            </p>
            <p class="text-muted mb-4" *ngIf="subscriptionKey && subscription?.type === SubscriptionType.EFT">
                EFT subscriptions are invoiced by ParkUpp and settled by bank transfer. Editing the contract terms here will not change how it is paid.
            </p>
        </div>
    </div>

    <div class="col-12" *ngIf="editAllowed">
        <form (ngSubmit)="onSubmit()" [formGroup]="formData" autocomplete="off" novalidate>
            <!-- Contract Details Section -->
            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0"><i class="fas fa-calendar-alt me-2"></i>Contract Details</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-md-4 mb-3">
                            <label>Enterprise</label>
                            <input [disabled]="true" class="form-control bg-light text-muted" type="text" [value]="enterpriseContext.currentEnterpriseDisplayName" />
                            <small class="text-muted">This subscription will be assigned to this enterprise.</small>
                        </div>

                        <div class="form-group col-md-4 mb-3">
                            <label>Payment Mechanism <i class="fas fa-lock ms-1 text-muted"></i></label>
                            <input [disabled]="true" class="form-control bg-light text-muted" type="text" [value]="subscription?.paymentMechanismName || 'Manual'" />
                            <small class="text-muted">The payment mechanism is fixed when the subscription is created and cannot be changed by editing.</small>
                        </div>

                        <div class="form-group col-md-4 mb-3">
                            <label>Created Date</label>
                            <input class="form-control" formControlName="createdAtDate" name="createdAtDate" type="date" />
                        </div>

                        <div class="form-group col-md-4 mb-3">
                            <label>Billing Period</label>
                            <input [disabled]="true" class="form-control bg-light" type="text" value="Monthly" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-md-4 mb-3">
                            <label>Start Date <span class="text-danger">*</span></label>
                            <input class="form-control" formControlName="startDate" name="startDate" type="date" />
                        </div>

                        <div class="form-group col-md-4 mb-3">
                            <label for="input-contractLength">Duration <span class="text-danger">*</span></label>
                            <div class="input-group">
                                <input class="form-control" formControlName="contractLength" id="input-contractLength" min="1" name="contractLength" type="number" />
                                <div class="input-group-text">
                                    <span>Months</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-md-4 mb-3">
                            <label>End Date</label>
                            <input [disabled]="true" class="form-control bg-light" formControlName="endDate" name="endDate" type="date" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-md-4 mb-3">
                            <label>Number of Bays <span class="text-danger">*</span></label>
                            <input class="form-control" formControlName="baysBooked" name="baysBooked" type="number" min="1" />
                        </div>

                        <div class="form-group col-md-4 mb-3">
                            <label>Monthly Fee <span class="text-danger">*</span></label>
                            <div class="input-group">
                                <div class="input-group-text">
                                    <span>R</span>
                                </div>
                                <input class="form-control" formControlName="feeInRands" inputCurrency name="feeInRands" placeholder="0.00" type="text" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Client Section -->
            <div class="card mb-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0"><i class="fas fa-user me-2"></i>Client <span class="text-danger">*</span></h5>
                    <div class="btn-group btn-group-sm">
                        <button type="button" class="btn" [class.btn-primary]="clientEntryMode === 'manual'" [class.btn-outline-secondary]="clientEntryMode !== 'manual'" (click)="setClientEntryMode('manual')">
                            <i class="fas fa-edit me-1"></i>Manual Entry
                        </button>
                        <button type="button" class="btn" [class.btn-primary]="clientEntryMode === 'linked'" [class.btn-outline-secondary]="clientEntryMode !== 'linked'" (click)="setClientEntryMode('linked')">
                            <i class="fas fa-link me-1"></i>Link Existing
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Manual Client Entry -->
                    <div *ngIf="clientEntryMode === 'manual'">
                        <div class="form-group">
                            <label>Client Name <span class="text-danger">*</span></label>
                            <input class="form-control" formControlName="manualClientName" placeholder="Enter client name (e.g., John Smith, Company ABC)" type="text" />
                            <small class="text-muted">Enter the client name as it appears in your external agreement.</small>
                        </div>
                    </div>

                    <!-- Linked Client Entry -->
                    <div *ngIf="clientEntryMode === 'linked'" class="row">
                        <div class="form-group col-md-6 mb-3">
                            <label>Search for Client</label>
                            <input
                                (typeaheadOnSelect)="onClientSelect($event.item)"
                                [typeaheadItemTemplate]="clientTemplate"
                                [typeaheadOptionField]="'searchField'"
                                [typeahead]="clientLookup"
                                [typeaheadMinLength]="1"
                                [typeaheadSelectFirstItem]="false"
                                [typeaheadOptionsLimit]="20"
                                class="form-control"
                                formControlName="clientName"
                                placeholder="Type to search..."
                            />
                            <ng-template #clientTemplate let-model="item">
                                {{ model.firstName }} {{ model.lastName }} <span class="text-muted">({{ model.companyName }})</span>
                            </ng-template>
                        </div>
                        <div class="form-group col-md-6 mb-3">
                            <label>Client Reference</label>
                            <input class="form-control bg-light" formControlName="clientKey" name="clientKey" type="text" readonly />
                            <small class="text-muted" *ngIf="formData.value.clientKey">
                                <a href="/client/{{ formData.value.clientKey }}" target="_blank"><i class="fas fa-external-link-alt me-1"></i>View Client</a>
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Merchant/Portfolio Section -->
            <div class="card mb-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0"><i class="fas fa-building me-2"></i>Portfolio <span class="text-danger">*</span></h5>
                    <div class="btn-group btn-group-sm">
                        <button type="button" class="btn" [class.btn-primary]="merchantEntryMode === 'manual'" [class.btn-outline-secondary]="merchantEntryMode !== 'manual'" (click)="setMerchantEntryMode('manual')">
                            <i class="fas fa-edit me-1"></i>Manual Entry
                        </button>
                        <button type="button" class="btn" [class.btn-primary]="merchantEntryMode === 'linked'" [class.btn-outline-secondary]="merchantEntryMode !== 'linked'" (click)="setMerchantEntryMode('linked')">
                            <i class="fas fa-link me-1"></i>Link Existing
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Manual Merchant Entry -->
                    <div *ngIf="merchantEntryMode === 'manual'">
                        <div class="form-group">
                            <label>Portfolio/Merchant Name <span class="text-danger">*</span></label>
                            <input class="form-control" formControlName="manualMerchantName" placeholder="Enter portfolio or merchant name" type="text" />
                            <small class="text-muted">Enter the landlord or portfolio name.</small>
                        </div>
                    </div>

                    <!-- Linked Merchant Entry -->
                    <div *ngIf="merchantEntryMode === 'linked'" class="row">
                        <div class="form-group col-md-6 mb-3">
                            <label>Search for Portfolio</label>
                            <input
                                (typeaheadOnSelect)="onMerchantSelect($event.item)"
                                [typeaheadItemTemplate]="merchantTemplate"
                                [typeaheadOptionField]="'companyName'"
                                [typeahead]="merchantLookup"
                                [typeaheadMinLength]="1"
                                [typeaheadSelectFirstItem]="false"
                                [typeaheadOptionsLimit]="20"
                                class="form-control"
                                formControlName="merchantName"
                                placeholder="Type to search..."
                                type="text"
                            />
                            <ng-template #merchantTemplate let-model="item">
                                {{ model.companyName }}
                            </ng-template>
                        </div>
                        <div class="form-group col-md-6 mb-3">
                            <label>Portfolio Reference</label>
                            <input class="form-control bg-light" formControlName="merchantKey" name="merchantKey" type="text" readonly />
                            <small class="text-muted" *ngIf="formData.value.merchantKey">
                                <a href="/merchant/{{ formData.value.merchantKey }}" target="_blank"><i class="fas fa-external-link-alt me-1"></i>View Portfolio</a>
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Parking Section -->
            <div class="card mb-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0"><i class="fas fa-parking me-2"></i>Parking <span class="text-danger">*</span></h5>
                    <div class="btn-group btn-group-sm">
                        <button type="button" class="btn" [class.btn-primary]="parkingEntryMode === 'manual'" [class.btn-outline-secondary]="parkingEntryMode !== 'manual'" (click)="setParkingEntryMode('manual')">
                            <i class="fas fa-edit me-1"></i>Manual Entry
                        </button>
                        <button type="button" class="btn" [class.btn-primary]="parkingEntryMode === 'linked'" [class.btn-outline-secondary]="parkingEntryMode !== 'linked'" (click)="setParkingEntryMode('linked')" [disabled]="merchantEntryMode === 'manual'">
                            <i class="fas fa-link me-1"></i>Link Existing
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Manual Parking Entry -->
                    <div *ngIf="parkingEntryMode === 'manual'">
                        <div class="form-group">
                            <label>Parking Location Name <span class="text-danger">*</span></label>
                            <input class="form-control" formControlName="manualParkingName" placeholder="Enter parking location name and address" type="text" />
                            <small class="text-muted">Enter the parking building name or address.</small>
                        </div>
                    </div>

                    <!-- Linked Parking Entry -->
                    <div *ngIf="parkingEntryMode === 'linked'">
                        <div *ngIf="!formData.value.merchantKey" class="alert alert-info">
                            <i class="fas fa-info-circle me-2"></i>Select a portfolio first to see available parkings.
                        </div>
                        <div *ngIf="formData.value.merchantKey" class="row">
                            <div class="form-group col-md-6 mb-3">
                                <label>Select Parking</label>
                                <select class="form-control" formControlName="parkingName" (change)="onParkingSelect($event)">
                                    <option value="">Select a Parking</option>
                                    <option *ngFor="let parking of parkingLookup" [value]="parking.$key">
                                        {{ parking.title }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-6 mb-3">
                                <label>Parking Reference</label>
                                <input class="form-control bg-light" formControlName="parkingKey" name="parkingKey" type="text" readonly />
                                <small class="text-muted" *ngIf="formData.value.parkingKey">
                                    <a href="/parking/{{ formData.value.parkingKey }}" target="_blank"><i class="fas fa-external-link-alt me-1"></i>View Parking</a>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="d-flex justify-content-between align-items-center mt-4 mb-5">
                <div>
                    <button [disabled]="!isFormValid() || formLoading" class="btn btn-primary me-2" type="submit">
                        <span *ngIf="formLoading"><i class="fas fa-spinner fa-spin me-2"></i>Saving...</span>
                        <span *ngIf="!formLoading"><i class="fas fa-save me-2"></i>{{ subscriptionKey ? 'Update' : 'Create' }} Subscription</span>
                    </button>
                    <a routerLink="/admin/subscriptions" class="btn btn-outline-secondary">
                        <i class="fas fa-times me-2"></i>Cancel
                    </a>
                </div>
                
                <div *ngIf="canDelete">
                    <button type="button" class="btn btn-outline-danger" (click)="deleteSubscription()" [disabled]="deleteLoading">
                        <span *ngIf="deleteLoading"><i class="fas fa-spinner fa-spin me-2"></i>Deleting...</span>
                        <span *ngIf="!deleteLoading"><i class="fas fa-trash me-2"></i>Delete Subscription</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
